import { useState } from 'react';
import { Link } from 'wouter';
import { SEOHead } from '../components/SEOHead';
import { Mail, ArrowRight } from 'lucide-react';

export default function AppLogin() {
  const [email, setEmail] = useState('');

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Login:', email);
  };

  return (
    <div className="min-h-screen bg-[var(--color-white)] flex flex-col">
      <SEOHead
        title="Login – pixcapture.app"
        description="Melden Sie sich bei pixcapture.app an"
        path="/app/login"
      />

      <main className="flex-1 flex items-center justify-center px-4">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <h1 className="text-[32px] mb-2">pixcapture.app</h1>
            <p className="text-[var(--color-grey)]">
              Mit E-Mail anmelden
            </p>
          </div>

          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-sm mb-2">E-Mail-Adresse</label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-[var(--color-grey)]" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-[var(--color-light-grey)] rounded-md focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)]"
                  placeholder="deine@email.de"
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              className="w-full bg-[var(--color-accent)] text-white py-3 rounded-md hover:opacity-90 transition-opacity flex items-center justify-center gap-2"
            >
              Weiter
              <ArrowRight className="h-5 w-5" />
            </button>
          </form>

          <div className="mt-8 text-center">
            <Link href="/">
              <a className="text-[var(--color-grey)] text-sm hover:text-[var(--color-accent)]">
                ← Zurück zur Startseite
              </a>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
